import { useEffect, useRef, useState } from 'react';
import { INITIAL_TIME_LEFT } from 'components/sessionTimeOut/SessionTimeoutModal/constants';
import { calcTimeCountDown } from 'components/sessionTimeOut/SessionTimeoutModal/utils/calcTimeCountDown';

export const useTimeLeftCountDown = ({ showModal, initialMin, initialSec, onTimeExpiration }) => {
    const countDownIntervalRef = useRef(null);
    const [{ minLeft, secLeft }, setTimeLeft] = useState(INITIAL_TIME_LEFT);

    const stopCountDown = () => {
        if (!countDownIntervalRef.current) return;
        clearInterval(countDownIntervalRef.current);
        countDownIntervalRef.current = null;
    };

    const startCountDown = () => {
        if (countDownIntervalRef.current) return;
        let min = initialMin;
        let sec = initialSec;

        setTimeLeft({
            minLeft: initialMin,
            secLeft: initialSec,
        });

        countDownIntervalRef.current = setInterval(() => {
            const newTime = calcTimeCountDown({ currentMin: min, currentSec: sec });
            sec = newTime.sec;
            min = newTime.min;

            setTimeLeft({
                minLeft: min,
                secLeft: sec,
            });
            if (min === 0 && sec === 0) {
                stopCountDown(countDownIntervalRef.current);
                onTimeExpiration();
            }
        }, 1000);
    };

    useEffect(() => {
        if (showModal) {
            startCountDown();
        } else {
            stopCountDown(countDownIntervalRef.current);
        }

        return () => stopCountDown();
    }, [showModal]);

    return { minLeft, secLeft };
};
